import React from 'react'
import { Redirect } from 'react-router-dom'
import { isFreeeLoggedIn, isGoogleLoggedIn, setAccessToken } from '../utils/AuthService'

const Auth = (props) => (isFreeeLoggedIn() && isGoogleLoggedIn() ? props.children : <Redirect to={'/'} />)

export default Auth